import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog';

const UpgradeModal = ({ open, onClose, feature = 'this feature', requiredPlan = 'a higher plan' }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate('/settings?tab=billing');
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="upgrade-modal">
        <DialogHeader>
          <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-amber-100 flex items-center justify-center">
            <Sparkles className="h-6 w-6 text-amber-600" />
          </div>
          <DialogTitle className="text-center">Upgrade Required</DialogTitle>
          <DialogDescription className="text-center">
            <strong className="text-slate-700">{feature}</strong> requires {requiredPlan}.
            Upgrade your subscription to unlock this feature.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col gap-2 sm:flex-col">
          <Button
            onClick={handleUpgrade}
            className="w-full bg-emerald-500 hover:bg-emerald-600 text-white"
            data-testid="upgrade-now-btn"
          >
            <CreditCard className="h-4 w-4 mr-2" />
            View Plans & Upgrade
          </Button>
          <Button
            variant="ghost"
            onClick={onClose}
            className="w-full"
          >
            Maybe Later
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradeModal;
